import { useContext } from 'react'
import { FirebaseContext } from '../context'

export function useApp() {
  return useContext(FirebaseContext)
}
